export default "__VITE_ASSET__Bbs4Gq4s__"